import styled from 'styled-components';

import { FontSizes, FontWeights, Hr, minWidth, Text, units } from '@calm-web/design-system';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column-reverse;
	gap: 20px;
	margin-top: ${units(4.5)};
	text-align: left;

	${minWidth('tablet')} {
		gap: 80px;
		flex-direction: row;
		margin-top: 0;
	}
`;

export const OverviewWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	gap: ${units(4)};
`;

export const ContentType = styled(Text).attrs({
	color: 'white',
	size: FontSizes.base,
	weight: FontWeights.Demi,
	el: 'p',
	noMargin: true,
})`
	&:not(:empty) {
		margin-bottom: ${units(1)};
	}
`;

export const Title = styled(Text).attrs({
	color: 'white',
	el: 'h1',
	size: FontSizes['2xl'],
	weight: FontWeights.Demi,
	noMargin: true,
})`
	margin-bottom: ${units(1.5)};
`;

export const Description = styled(Text).attrs({
	color: 'white',
	el: 'h2',
	weight: FontWeights.Regular,
	size: FontSizes.base,
	noMargin: true,
})``;

export const HorizontalLine = styled(Hr).attrs({
	color: 'whiteAlpha40',
})``;

export const ImageWrapper = styled.div`
	height: 113px;
	width: 113px;
	border-radius: 20px;
	position: relative;
	overflow: hidden;
	flex-shrink: 0;
	align-self: center;

	${minWidth('tablet')} {
		height: 294px;
		width: 294px;
		align-self: start;
	}
`;
